import React from 'react';
import { Breakpoint } from '@altibox/design-system-component-lib';
import { useSelector } from 'react-redux';

import { i18n } from 'app/i18n';
import { OrderInformationUtils } from 'app/pages/order/utils/order-information-utils';
import { selectSelectedServiceLocation, selectSelectedUserDetails } from 'app/pages/order/redux/order-selector';

import { StyledFooterUserInfo, StyledFooterText } from './footer-customer-information.styled';

export const FooterCustomerInformation = () => {
    const userDetails = useSelector(selectSelectedUserDetails);
    const serviceLocation = useSelector(selectSelectedServiceLocation);

    if (!userDetails) {
        return null;
    }

    return (
        <StyledFooterUserInfo>
            <StyledFooterText
                component="p"
                variant="paragraph2"
                maxBreakpoint={Breakpoint.TABLET}
                data-hj-suppress={true}
            >
                {OrderInformationUtils.getFullName(userDetails)}
            </StyledFooterText>
            {serviceLocation && (
                <StyledFooterText
                    component="p"
                    variant="paragraph2"
                    maxBreakpoint={Breakpoint.TABLET}
                    data-hj-suppress={true}
                >
                    {OrderInformationUtils.getShortAddress(serviceLocation)}
                </StyledFooterText>
            )}
            <StyledFooterText
                component="p"
                variant="paragraph2"
                maxBreakpoint={Breakpoint.TABLET}
                data-hj-suppress={true}
            >
                {`${i18n.components.footer.customerNumber}: ${userDetails.billingAccountId}`}
            </StyledFooterText>
        </StyledFooterUserInfo>
    );
};
